module.exports = __webpack_public_path__ + "img/tet20201.f610b69f.png";